import { SxProps, Theme } from '@mui/material';

export const kitTableItemQuantitySX: SxProps<Theme> = {
	width: { xs: '60px', md: '100px' },
};

export const kitTableItemQuantityLabelSX: SxProps<Theme> = {
	color: 'grey.300',
};
